export const movieConstant = {
    SEARCH_FAIL: 'SEARCH_MOVIE_FAIL',
    SEARCH_SUCCESS: 'SEARCH_MOVIE_SUCCESS',
    SEARCH_REQUEST: 'SEARCH_MOVIE_REQUEST',
    SEARCH_AUTHOR_FAIL: 'SEARCH_AUTHOR_FAIL',
    SEARCH_AUTHOR_SUCCESS: 'SEARCH_AUTHOR_SUCCESS',
    SEARCH_AUTHOR_REQUEST: 'SEARCH_AUTHOR_REQUEST',
    ADD_FAIL: 'ADD_MOVIE_FAIL',
    ADD_SUCCESS: 'ADD_MOVIE_SUCCESS',
    ADD_REQUEST: 'ADD_MOVIE_REQUEST',
    PAGINATE_FAIL: 'PAGINATE_MOVIE_FAIL',
    PAGINATE_SUCCESS: 'PAGINATE_MOVIE_SUCCESS',
    PAGINATE_REQUEST: 'PAGINATE_MOVIE_REQUEST',
    GET_FAIL: 'GET_MOVIE_FAIL',
    GET_SUCCESS: 'GET_MOVIE_SUCCESS',
    GET_REQUEST: 'GET_MOVIE_REQUEST',
    SHOULD_FAIL: 'SHOULD_MOVIE_FAIL',
    SHOULD_SUCCESS: 'SHOULD_MOVIE_SUCCESS',
    SHOULD_REQUEST: 'SHOULD_MOVIE_REQUEST',
    RESET: 'RESET_MOVIE',
    ADD_LIST_FAIL: 'ADD_WATCH_LIST_MOVIE_FAIL',
    ADD_LIST_SUCCESS: 'ADD_WATCH_LIST_SUCCESS',
    ADD_LIST_REQUEST: 'ADD_WATCH_LIST_REQUEST',
};

export default movieConstant;